import React, { useEffect } from "react";
import { IStudentAccountsDetail } from "../../../../../models/student/studentAccountsDetails";
import { termMonths } from "../../../../../constants/monthConstants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStudentAccountDetail } from "../../../../../store/slices/student/studentAccountDetailSlice";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { Chart } from "primereact/chart";
import { getStudentAccountDetail } from "../../../../../action/student/studentAccountDetailsActionCreator";
import { connect } from "react-redux";

const BetaStudentAccount = (props: IStudentAccountsDetail) => {
  const { getStudentAccount, accountDetails } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getStudentAccount();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setStudentAccountDetail([]));
    };
  }, []);

  const handleViewPage = () => {
    navigate(ROUTER_URL.STUDENT_ACCOUNTS);
  };

  const lastTwelveMonth = accountDetails?.currentNetBalance
    ?.slice(-12)
    ?.map((m) => {
      return m.month;
    });

  const currentNetBalances = lastTwelveMonth?.map((month) => {
    const matchedMonth = accountDetails?.currentNetBalance?.find(
      (details) => details.month?.toLowerCase() === month?.toLocaleLowerCase()
    );
    return matchedMonth?.netBalance || 0;
  });

  const futureNetBalances = lastTwelveMonth?.map((month) => {
    const matchedMonth = accountDetails?.futureNetBalance?.find(
      (details) =>
        details.month?.toLocaleLowerCase() === month?.toLocaleLowerCase()
    );
    return matchedMonth?.netBalance || 0;
  });

  const date = new Date();
  const currentTerm = Math.ceil((date.getMonth() + 1) / 3);

  const currentTermMonths = termMonths[currentTerm];

  const currentTermBalance = currentTermMonths.reduce((total, month) => {
    const matchedMonth = accountDetails?.currentNetBalance?.find(
      (m) => m.month?.toLocaleLowerCase() === month
    );

    if (matchedMonth) {
      return total + (matchedMonth.netBalance ? matchedMonth.netBalance : 0);
    } else {
      return total;
    }
  }, 0);

  const futureTermBalance = currentTermMonths.reduce((total, month) => {
    const matchedMonth = accountDetails?.futureNetBalance?.find(
      (m) => m.month?.toLocaleLowerCase() === month
    );

    if (matchedMonth) {
      return total + (matchedMonth.netBalance ? matchedMonth.netBalance : 0);
    } else {
      return total;
    }
  }, 0);

  const data = {
    labels: lastTwelveMonth,
    datasets: [
      {
        label: "Future Net Balance", // Optional label for the line
        data: currentNetBalances, // Data for each month
        borderColor: "#0161fa", // Line color
        fill: false, // No fill under the line
        tension: 0.1, // Smooth curve
        backgroundColor: "#0161fa", // Icon color in the legend
        pointBorderColor: "#0161fa",
      },
      {
        label: "Current Net Balance",
        data: futureNetBalances,
        borderColor: "#0bc1ff",
        fill: false,
        tension: 0.1,
        backgroundColor: "#0bc1ff", // Icon color in the legend
        pointBorderColor: "#0bc1ff",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          useLineStyle: true,
          padding: 10,
        },
      },
    },
  };

  return (
    <>
      <div className="card h-100 student_metrics">
        <a onClick={handleViewPage}>
          <div className="top">
            <div className="img">
              <img src="/assets/images/icon/activity.svg" alt="" />
            </div>
            <div className="desc">
              <h2>Student Account</h2>
              <span>{accountDetails?.description}.</span>
            </div>
          </div>
          <div className="stud-acc-legend">
            <div>
              <span></span>Future Net Balance
            </div>
            <div>
              <span></span>Current Term Balance
            </div>
          </div>
          <Chart
            type="line"
            data={data}
            options={options}
            className=""
            width="300"
          />
          <ul className="desc d-flex justify-content-around mt-2 studeacc-desc">
            <li>
              <label>
                <span></span>Future Net Balance
              </label>
              <h2>${futureTermBalance}</h2>
            </li>
            <li>
              <label>
                <span></span>Current Term Balance
              </label>
              <h2>${currentTermBalance}</h2>
            </li>
          </ul>
        </a>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentAccount: () => getStudentAccountDetail(),
};

function mapStateToProps(state: any) {
  return {
    accountDetails: state.studentAccountDetail.accountDetail,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BetaStudentAccount);
